import { Link } from 'react-router-dom';
import Segment from '../shared/segment';
import NavLink from '../shared/buttons/nav-link';

function NoDeck() {
  return (
    <Segment className='leading-8'>
      <p className='text-center'>داوطلب گرامی، شما هیچ بسته فلش کارت فعالی ندارید.</p>
      <p className='text-center'>
        لطفا برای خرید بسته فلش کارت مورد نظر خود به
        <Link to='/store' className='text-blue-600'>
          {' '}
          فروشگاه{' '}
        </Link>
        مراجعه کنید.
      </p>
      <p className='text-center'>
        <span>همچنین با مراجعه به فروشگاه می‌توانید از </span>
        <span className='font-medium text-pink-500'>بسته‌های تستی رایگان</span>
        <span> مدمشاور نیز استفاده کنید.</span>
      </p>
      <NavLink to='/store' color='green' content='فروشگاه' className='mx-auto my-4' />
    </Segment>
  );
}

export default NoDeck;
